import React from 'react';
import { connect } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import { logout } from '../../actions';
import UserCard from '../user-card';
import { theme } from '../../theme';

const UserMenu = (props) => {
  const {
    // menuBackground,
    // menuBorderColor,
    // menuTextColor,
    // fontSize,
    // fontWeight,
    menuItemTextColor,
    menuItemActiveTextColor,
    menuItemHoverTextColor,
    // menuItemDisabledTextColor,
    // menuItemDisabledTextColorOpacity,
    menuItemBackgroundColor,
    menuItemActiveBackgroundColor,
    menuItemHoverBackgroundColor,
    // menuItemDisabledBackgroundColor,
    // menuItemIndicatorColor,
    // menuItemActiveIndicatorColor,
    // menuItemHoverIndicatorColor,
    menuItemSeparatorColor
  } = theme.dropdown;
  const styles = StyleSheet.create({
    userCard: {
      background: '#083050',
      width: '302px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    menuItemIndicator: {
      width: '2px',
      height: '40px'
    },
    menuItem: {
      background: menuItemBackgroundColor,
      color: menuItemTextColor,
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      width: '100%',
      font: 'bold 14px Lato',
      paddingLeft: '4px',
      cursor: 'pointer',
      ':hover:not(.activeitem)': {
        color: menuItemHoverTextColor,
        background: menuItemHoverBackgroundColor
      }
    },
    menuItemActive: {
      background: menuItemActiveBackgroundColor,
      color: menuItemActiveTextColor
    }
  });

  const location = useLocation();

  return (
    <div className={`p2 ${css(styles.userCard)}`}>
      {/* User card */}
      <UserCard
        userHandle={`@${props.usr ? props.usr.userName : ''}`}
        displayName={props.usr ? props.usr.displayName : ''}
        isActive={location.pathname.startsWith('/admin')}
        setVisibility={props.setVisibility}
      />

      {/* Security & Settings */}
      <NavLink
        to='/settings/loginCredentials'
        className={css(styles.menuItem, location.pathname.startsWith('/settings') && styles.menuItemActive)}
        onClick={() => { props.setVisibility(false); }}
      >
        <div
          style={{
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          <div
            className="fx fx__hv-center"
            style={{
              height: '40px',
              width: '40px'
            }}
          >
            <i style={{ fontSize: '24px' }} className="fa fa-cog" />
          </div>
          <div>Security &amp; Settings</div>
        </div>
      </NavLink>

      {/* Contact */}
      <div
        className={css(styles.menuItem)}
        style={{
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          borderBottom: `1px solid ${menuItemSeparatorColor}`,
          cursor: 'pointer'
        }}
      >
        <div
          className="fx fx__hv-center"
          style={{
            height: '40px',
            width: '40px'
          }}
        >
          <i style={{ fontSize: '24px' }} className="fa fa-headphones" />
        </div>
        <div>Contact</div>
      </div>

      {/* Logout */}
      <div
        onClick={() => props.logout()}
        className={css(styles.menuItem)}
        style={{
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid #001824',
          cursor: 'pointer'
        }}
      >
        <div
          className="fx fx__hv-center"
          style={{
            height: '40px',
            width: '40px'
          }}
        >
          <i style={{ fontSize: '24px' }} className="fa fa-sign-out" />
        </div>
        <div>Logout</div>
      </div>
    </div>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}

export default connect(
  mapStateToProps, {
    logout
  })(UserMenu);
